module.exports = __webpack_public_path__ + "img/banner_image.c3326e9a.png";